import { useState } from "react";
import { Button, Card, CardContent, Stack, Typography } from "@mui/material";
import DocumentList from "./DocumentList";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import MoveUpIcon from "@mui/icons-material/MoveUp";
import SendIcon from "@mui/icons-material/Send";
import DocumentTransmittalModal from "./DocTransmittalMadal";
import { useDCS } from "../DCSContext";

export default function DocumentListCard({ type }) {
  const [docListState, setDocListState] = useState(false);
  const [docTransState, setDocTransState] = useState(false);
  const {
    documentList,
    getDocList,
    setCurrentDocsReviewer,
    selectedDocuments,
    setSelectedDocuments,
  } = useDCS();
  console.log(type);

  const handleSendDocuments = () => {
    if (selectedDocuments.length === 0) {
      alert("Please select at least one document to send.");
      return;
    }
    console.log("selectedDocuments", selectedDocuments);
    setCurrentDocsReviewer("doc-transmittal");
  };

  const handleDocumentListClose = () => {
    getDocList();
    setDocListState(false);
  };
  const handleDocTransClose = () => {
    setDocTransState(false);
  };
  return (
    <>
      <Card
        key={5}
        sx={{ width: "288px" }}
        onClick={() => {
          setCurrentDocsReviewer("");
        }}
      >
        <CardContent>
          <Typography fontSize={"12px"} fontWeight={600} component="div">
            {type} List
          </Typography>
          <Stack
            direction="row"
            paddingTop={1}
            sx={{ justifyContent: "space-between" }}
          >
            <Typography variant="h5">{documentList.length}</Typography>
            <Button
              sx={{
                backgroundColor: "#28E8F6",
                cursor: "default",
                cursorEvents: "none",
                "&:hover": {
                  backgroundColor: "#28E8F6",
                  cursor: "pointer",
                },
              }}
              onClick={() => {
                setDocListState(true);
              }}
            >
              <FileCopyIcon sx={{ color: "#5D4108FF" }} />
            </Button>
          </Stack>
        </CardContent>
      </Card>
      <DocumentList
        open={docListState}
        handleClose={handleDocumentListClose}
        type={type}
      />
      <Card key={7} sx={{ width: "288px" }}>
        <CardContent>
          <Typography fontSize={"12px"} fontWeight={600} component="div">
            Documents Transmittal
          </Typography>
          <Stack
            direction="row"
            paddingTop={1}
            sx={{ justifyContent: "space-between", alignItems: "center" }}
          >
            <Typography variant="h5">{selectedDocuments.length}</Typography>
            <Stack direction="row" spacing={1}>
              <Button
                sx={{
                  backgroundColor: "#EFC3CA",
                  "&:hover": {
                    backgroundColor: "#EFC3CA",
                  },
                  minWidth: "auto",
                  padding: "8px",
                }}
                onClick={() => {
                  setCurrentDocsReviewer("doc-transmittal");
                }}
                title="Open Document Transmittal"
              >
                <MoveUpIcon sx={{ color: "#5D4108FF" }} />
              </Button>
              <Button
                sx={{
                  backgroundColor: "#4CAF50",
                  "&:hover": {
                    backgroundColor: "#45a049",
                  },
                  minWidth: "auto",
                  padding: "8px",
                }}
                onClick={handleSendDocuments}
                disabled={selectedDocuments.length === 0}
                title="Send Selected Documents"
              >
                <SendIcon sx={{ color: "#FFFFFF" }} />
              </Button>
            </Stack>
          </Stack>
        </CardContent>
      </Card>
      <DocumentTransmittalModal
        open={docTransState}
        handleClose={handleDocTransClose}
        type={type}
      />
    </>
  );
}
